export const mainTitle = "Pontes"
export const mainUrl = "/"
export const mainDescription = "Semana do cinema galego e portugués"
export const impulsaUrl = "https://impulsa.abella.gal"
export const siteUrl = "https://pontes.abella.gal"
